import { render, staticRenderFns } from "./StudentEditPassword.vue?vue&type=template&id=b9243dbc"
import script from "./StudentEditPassword.vue?vue&type=script&lang=js"
export * from "./StudentEditPassword.vue?vue&type=script&lang=js"
import style0 from "./StudentEditPassword.vue?vue&type=style&index=0&id=b9243dbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports